import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_THEORETICAL_TRAINING_PARTICIPANT,
  CREATE_THEORETICAL_TRAINING,
  DELETE_THEORETICAL_TRAINING,
  DELETE_THEORETICAL_TRAINING_PARTICIPANT,
  GET_ALL_THEORETICAL_TRAINING,
  GET_CANDIDATE_THEORETICAL_ASSESSMENT_DETAILS,
  GET_MATCHED_THEORETICAL_CANDIDATES,
  GET_THEORETICAL_PARTICIPANT_ASSESSMENT_DETAILS,
  GET_THEORETICAL_TRAINING_DETAILS,
  GET_THEORETICAL_TRAINING_PARTICIPANTS,
  GET_THEORETICAL_TRAINING_PARTICIPANTS_ASSESSMENT_QUESTIONS,
  GET_TRAINING_MATERIAL_LIST,
  MARK_MULTIPLE_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  MARK_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  SUBMIT_THEORETICAL_PARTICIPANT_ASSESSMENT,
  THEORETICAL_PARTICIPANT_OPEN_ASSESSMENT,
  UPDATE_THEORETICAL_TRAINING,
  RESET_THEORETICAL_TRAINING_ASSESSMENT,
} from "helpers/url_helper"

export const getAllTheoreticalTrainings = createAsyncThunk(
  GET_ALL_THEORETICAL_TRAINING,
  async payload => {
    const response = await post(GET_ALL_THEORETICAL_TRAINING, payload)
    return response
  }
)

export const createTheoreticalTraining = createAsyncThunk(
  CREATE_THEORETICAL_TRAINING,
  async payload => {
    const response = await post(CREATE_THEORETICAL_TRAINING, payload)
    return response
  }
)

export const updateTheoreticalTraining = createAsyncThunk(
  UPDATE_THEORETICAL_TRAINING,
  async ({ uuid, payload }) => {
    const response = await put(
      `${UPDATE_THEORETICAL_TRAINING}/${uuid}`,
      payload
    )
    return response
  }
)

export const deleteTheoreticalTraining = createAsyncThunk(
  DELETE_THEORETICAL_TRAINING + "DELETE",
  async uuid => {
    const response = await del(`${DELETE_THEORETICAL_TRAINING}/${uuid}`)
    return response
  }
)

export const getTrainingMaterialList = createAsyncThunk(
  GET_TRAINING_MATERIAL_LIST,
  async uuid => {
    const response = await get(GET_TRAINING_MATERIAL_LIST)
    return response
  }
)

export const getTrainingMaterialDetails = createAsyncThunk(
  GET_THEORETICAL_TRAINING_DETAILS,
  async uuid => {
    const response = await get(`${GET_THEORETICAL_TRAINING_DETAILS}/${uuid}`)
    return response
  }
)

export const getTheoreticalTrainingParticipants = createAsyncThunk(
  GET_THEORETICAL_TRAINING_PARTICIPANTS,
  async payload => {
    const response = await post(GET_THEORETICAL_TRAINING_PARTICIPANTS, payload)
    return response
  }
)

export const theoreticalParticipantOpenAssessment = createAsyncThunk(
  THEORETICAL_PARTICIPANT_OPEN_ASSESSMENT,
  async payload => {
    const response = await post(
      THEORETICAL_PARTICIPANT_OPEN_ASSESSMENT,
      payload
    )
    return response
  }
)

export const addTheoreticalTrainingParticipant = createAsyncThunk(
  ADD_THEORETICAL_TRAINING_PARTICIPANT,
  async payload => {
    const response = await post(ADD_THEORETICAL_TRAINING_PARTICIPANT, payload)
    return response
  }
)

export const deleteTheoreticalTrainingParticipant = createAsyncThunk(
  DELETE_THEORETICAL_TRAINING_PARTICIPANT,
  async uuid => {
    const response = await del(
      `${DELETE_THEORETICAL_TRAINING_PARTICIPANT}/${uuid}`
    )
    return response
  }
)

export const markTheoreticalTrainingParticipantAttendance = createAsyncThunk(
  MARK_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  async payload => {
    const response = await post(
      MARK_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
      payload
    )
    return response
  }
)

export const markMultipleTheoreticalTrainingParticipantAttendance =
  createAsyncThunk(
    MARK_MULTIPLE_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
    async payload => {
      const response = await post(
        MARK_MULTIPLE_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE,
        payload
      )
      return response
    }
  )

export const getTheoreticalAssessmentQuestions = createAsyncThunk(
  GET_THEORETICAL_TRAINING_PARTICIPANTS_ASSESSMENT_QUESTIONS,
  async () => {
    const response = await get(
      GET_THEORETICAL_TRAINING_PARTICIPANTS_ASSESSMENT_QUESTIONS
    )
    return response
  }
)

export const submitTheoreticalParticipantAssessment = createAsyncThunk(
  SUBMIT_THEORETICAL_PARTICIPANT_ASSESSMENT,
  async payload => {
    const response = await post(
      SUBMIT_THEORETICAL_PARTICIPANT_ASSESSMENT,
      payload
    )
    return response
  }
)

export const getCandidateTheoreticalAssessmentDetails = createAsyncThunk(
  GET_CANDIDATE_THEORETICAL_ASSESSMENT_DETAILS,
  async uuid => {
    const response = await get(
      `${GET_CANDIDATE_THEORETICAL_ASSESSMENT_DETAILS}/${uuid}`
    )
    return response
  }
)

export const getMatchedTheoreticalCandidates = createAsyncThunk(
  GET_MATCHED_THEORETICAL_CANDIDATES,
  async payload => {
    const response = await post(GET_MATCHED_THEORETICAL_CANDIDATES, payload)
    return response
  }
)

export const getTheoreticalParticipantAssessmentDetails = createAsyncThunk(
  GET_THEORETICAL_PARTICIPANT_ASSESSMENT_DETAILS,
  async uuid => {
    const response = await get(
      `${GET_THEORETICAL_PARTICIPANT_ASSESSMENT_DETAILS}/${uuid}`
    )
    return response
  }
)

export const resetTheoreticalTrainingAssessment = createAsyncThunk(
  RESET_THEORETICAL_TRAINING_ASSESSMENT,
  async payload => {
    const response = await post(RESET_THEORETICAL_TRAINING_ASSESSMENT, payload)
    return response
  }
)
